export const DEFAULT_CRITERIA = {
  groupBySelectedSlaType: false,
  groupByAvailableDeliveryWindows: false,
  slaOptions: false,
  selectedSla: true,
  seller: true,
  shippingEstimate: true,
  deliveryChannel: true,
  useMarketplaceItems: true,
}

export const PICKUP_IN_STORE = 'pickup-in-point'
export const DELIVERY = 'delivery'
export const PICKUP = 'pickup'
export const TAKE_AWAY = 'take-away'

export const RESIDENTIAL = 'residential'
export const COMMERCIAL = 'commercial'
export const GIFT_REGISTRY = 'giftRegistry'

export const SEARCH = 'search'

export const SLA_TYPES = {
  TAKE_AWAY,
  DELIVERY,
  PICKUP_IN_STORE,
}
